import { render } from "./CvPage.vue?vue&type=template&id=1280409e&scoped=true"
import script from "./CvPage.vue?vue&type=script&lang=js"
export * from "./CvPage.vue?vue&type=script&lang=js"

import "./CvPage.vue?vue&type=style&index=0&id=1280409e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1280409e"]])

export default __exports__